import { render, staticRenderFns } from "./midi-player.vue?vue&type=template&id=0d297748&scoped=true"
import script from "./midi-player.vue?vue&type=script&lang=js"
export * from "./midi-player.vue?vue&type=script&lang=js"
import style0 from "./midi-player.vue?vue&type=style&index=0&id=0d297748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d297748",
  null
  
)

export default component.exports